import { NotificationInbox } from "@/components/notifications/NotificationInbox";
import { PageContainer } from "@/components/shared/PageContainer";
import { PageHeader } from "@/components/shared/PageHeader";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useMarkAllNotificationsRead, useUnreadNotifications } from "@/hooks/use-notifications";

/**
 * Notifications — the signed-in user's own inbox, full screen. New holds what is still
 * unread; dismissing a notice moves it to All, which keeps everything as history.
 */
export function NotificationsPage() {
  const { data } = useUnreadNotifications();
  const dismissAll = useMarkAllNotificationsRead();
  const unread = data?.unreadCount ?? 0;

  return (
    <PageContainer>
      <PageHeader
        title="Notifications"
        description="What has changed that needs your attention?"
        actions={
          unread > 0 && (
            <Button disabled={dismissAll.isPending} onClick={() => dismissAll.mutate()}>
              Dismiss all
            </Button>
          )
        }
      />
      <Tabs defaultValue="new">
        <TabsList>
          <TabsTrigger value="new">New{unread > 0 ? ` · ${unread}` : ""}</TabsTrigger>
          <TabsTrigger value="all">All</TabsTrigger>
        </TabsList>
        <TabsContent value="new">
          <NotificationInbox view="new" />
        </TabsContent>
        <TabsContent value="all">
          <NotificationInbox view="all" />
        </TabsContent>
      </Tabs>
    </PageContainer>
  );
}
